import { Checkbox } from "@headlessui/react";
import { cva } from "class-variance-authority";
import { forwardRef, useEffect, useRef } from "react";
import { CheckIcon } from "../../icons/CheckIcon";
import { MinusIcon } from "../../icons/MinusIcon";

export const checkboxStyles = cva([
	"group after:-inset-2 relative block size-4 shrink-0 rounded-sm border border-neutral bg-white after:absolute after:content-[''] hover:cursor-pointer focus:ring-2 focus:ring-primary data-[checked]:border-primary data-[indeterminate]:border-primary data-[checked]:bg-primary data-[indeterminate]:bg-primary data-[disabled]:opacity-50 data-[disabled]:hover:cursor-not-allowed",
]);

export type BaseCheckboxProps = {
	value: boolean;
	onChange?: (checked: boolean) => void;
	indeterminate?: boolean;
	isDisabled?: boolean;
};

export const BaseCheckboxInner = (
	{ value = false, onChange, indeterminate, isDisabled, ...rest }: BaseCheckboxProps,
	ref: React.ForwardedRef<HTMLInputElement>,
) => {
	const inputRef = useRef<HTMLInputElement>(null);
	useEffect(() => {
		if (inputRef?.current && typeof indeterminate === "boolean") {
			inputRef.current.indeterminate = indeterminate;
		}
	}, [indeterminate]);

	return (
		<Checkbox
			checked={value}
			onChange={(x) => onChange?.(x)}
			disabled={isDisabled}
			indeterminate={indeterminate}
			className={checkboxStyles()}
			ref={(node) => {
				if (ref) {
					// @ts-ignore
					ref.current = node;
				}

				// @ts-ignore
				inputRef.current = node;
			}}
			{...rest}
		>
			<span className="flex h-[14px] w-[14px] items-center justify-center">
				{/* Checkmark icon */}
				{!indeterminate && <CheckIcon className="h-3 w-3 stroke-[4] stroke-white" />}

				{/* Indeterminate icon */}
				{indeterminate && <MinusIcon className="h-3 w-3 stroke-[4] stroke-white" />}
			</span>
		</Checkbox>
	);
};

BaseCheckboxInner.displayName = "BaseCheckbox";

export const BaseCheckbox = forwardRef(BaseCheckboxInner);
